// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var InProgress = function InProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#inprogress-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.875 10A8.124 8.124 0 0 1 10 1.875v16.25A8.124 8.124 0 0 1 1.875 10M20 10a10 10 0 1 0-20 0 10 10 0 0 0 20 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.418,
    cy: 8.418,
    r: 7.918,
    stroke: "currentColor",
    transform: "matrix(-1 0 0 1 18.438 1.563)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inprogress-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 0H0v20h20z"
  }))));
};
